module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("Also by William McIlvanney")]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_vm._v("Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("Remedy is None")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("Gift from Nessus")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("The Big Man")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("Walking Wounded")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("The Kiln")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("Weekend")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_vm._v("The Detective Laidlaw trilogy")]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("Laidlaw")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("The Papers of Tony Veitch")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("Strange Loyalties")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_vm._v("Poetry")]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("The Longships in Harbour")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("In Through the Head")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("These Words: Weddings and After")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi2"
  }, [_vm._v("Non Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("Shades of Grey – Glasgow 1956–1987, with Oscar Marzaroli")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi5"
  }, [_c('i', [_vm._v("Surviving the Shipwreck")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237f7f00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_Front01.vue
// module id = 60
// module chunks = 0